import { render } from "./Detailed.vue?vue&type=template&id=5e5ca38b&scoped=true"
import script from "./Detailed.vue?vue&type=script&lang=js"
export * from "./Detailed.vue?vue&type=script&lang=js"

import "./Detailed.vue?vue&type=style&index=0&id=5e5ca38b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5ca38b"]])

export default __exports__